// extracted by mini-css-extract-plugin
module.exports = {"page":"SignupPage_page__3nNQw"};